import { makeStyles, Title2, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

export interface ProfileSectionProps {
	title: string;
	content: ReactNode;
	actions?: ReactNode;
}

export default function ProfileSection(props: ProfileSectionProps) {
	const styles = useStyles();

	return (
		<div className={styles.profileContainer}>
			<div className={styles.title}>
				<Title2>{props.title}</Title2>
				<div className={styles.actions}>
					{props.actions && props.actions}
				</div>
			</div>

			<div className={styles.content}>{props.content}</div>
		</div>
	);
}

const useStyles = makeStyles({
	profileContainer: {
		backgroundColor: tokens.colorNeutralBackground1,
		borderRadius: '5px',
		margin: '35px 0px'
	},
	title: {
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '10px',
		backgroundColor: tokens.colorBrandBackground,
		borderTopLeftRadius: '5px',
		borderTopRightRadius: '5px'
	},
	actions: {},
	content: {
		padding: '18px 15px'
	}
});
